import { FgStatusEnum, GlobalStatus, GradeInvStatusEnum, PlantsEnum, ShiftsEnum, SubPlantCodesEnum, TransferStatusEnum, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("stock_transfer_log")
export class StockTransferLog {

    @PrimaryGeneratedColumn("increment", { name: 'transfer_log_id' })
    transferLogId: number;

    @Column("int", {
        nullable: true,
        name: "production_log_id",
        default:'0'
    })
    productionLogId: number;

    @Column("int", {
        nullable: false,
        name: "production_inv_id"
    })
    productionInvId: number;


    @Column("int", {
        nullable: false,
        name: "new_production_inv_id"
    })
    newProductionInvId: number;

    @Column('int', {
        nullable: false,
        name: "plant_id"
    })
    plantId: number;

    @Column({
        nullable: false,
        name: 'sub_plant_id'
    })
    subPlantId: number;

    @Column("varchar", {
        nullable: true,
        name: "dc_number",
        length: 50
    })
    dcNumber: string;

    @Column("varchar", {
        nullable: true,
        name: "mrn_number",
        length: 50
    })
    mrnNumber: string;

    @Column("int", {
        nullable: true,
        name: "send_boxes",
        default:0
    })
    sendBoxes: number;

    @Column("int", {
        nullable: true,
        name: "receive_boxes",
        default:0
    })
    receiveBoxes: number;

    @Column("int", {
        nullable: true,
        name: "send_count"
    })
    sendCount: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: true,
        default: 0,
        name: "send_quantity"
    })
    sendQuantity: number;

    @Column("int", {
        nullable: true,
        name: "received_count"
    })
    receviedCount: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: true,
        default: 0,
        name: "recevied_quantity"
    })
    receviedQuantity: number;

    @Column({
        nullable: false,
        name: "estimated_date"
    })
    estimatedDate: Date;

    @Column({
        nullable: true,
        name: "received_date"
    })
    receivedDate: Date;

    @Column({
        type: 'enum',
        enum: TransferStatusEnum,
        nullable: true,
        default: TransferStatusEnum.IN_TRANSIT,
        name: 'status'
    })
    status: TransferStatusEnum;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}